export function authHeader() {
    let data = JSON.parse(localStorage.getItem('profile'));
    let user = data?.data?.user;
    let token = data?.data?.token;
    let language = user?.language ?? localStorage.getItem('language') ?? 'fr';

    if (token) {
        return {
            'Authorization': 'Bearer ' + token,
            'X-Requested-With': 'XMLHttpRequest',
            'Accept-Language': language ?? 'fr',
        };
    } else {
        return {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept-Language': language ?? 'fr',
        };
    }
}

export function guestHeader() {
    let language = localStorage.getItem('language') ?? 'fr';
    
    return {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept-Language': language??'fr',
    };
}